import { Box, DialogTitle, Grid, IconButton, ListItem, styled, Tab, Tabs, Typography } from '@mui/material';
import { displayFlexAlignCenter, flexCenter, flexStart } from 'theme/styleConstant';

export const AuthLayoutContainer = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(3),
  minHeight: 'calc(100vh - 169px)',
  ...flexCenter,

  [theme.breakpoints.down('md')]: {
    paddingInline: theme.spacing(2),
  },
}));

export const PlainLayoutContainer = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(3),
  minHeight: 'calc(100vh - 100px)',
  ...flexStart,
  justifyContent: 'center',

  [theme.breakpoints.down('md')]: {
    paddingInline: theme.spacing(2),
  },
}));

export const DrawerContentBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(5),
  paddingTop: theme.spacing(0),
  marginTop: theme.spacing(4.375),

  [theme.breakpoints.down('lg')]: {
    width: '100%',
    padding: theme.spacing(11, 2, 2),
  },

  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: theme.spacing(8, 2, 2),
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  borderRadius: theme.spacing(2, 2, 0, 0),
  backgroundColor: theme.palette.customShadowColor.main,
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'capitalize',
  color: theme.palette.customGrayColor.main,
}));

export const LightGreyCardBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.customShadowColor.main,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
}));

export const DarkGreyCardBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.customBlackColor.dark,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
}));

export const PaymentMethodContainer = styled(Grid)({
  width: '100%',
  maxWidth: 1280,
});

export const TimerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  position: 'relative',
  width: '100%',
  maxWidth: '300px',
  margin: '0 auto',
}));

export const CircularProgressContainer = styled(Box)({
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const TimeDisplay = styled(Typography)({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
});

export const ModalCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: 12,
  top: 12,
  color: theme.palette.primary.main,
}));

export const UserSettingListItem = styled(ListItem)(({ theme }) => ({
  ...displayFlexAlignCenter,
  gap: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
  cursor: 'pointer',
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(2),
}));
